<template>
    <div class="data-loader">
        {{ title }}
    </div>
</template>

<style lang="scss" scoped>

    /* .data-loader {
        width: 100%;
        height: 100%;
    }

    .data-loader,
    .data-loader * {
        font-family: "BLOKK" !important;
        color: #eee;
    } */

</style>


<script>
export default {
    props: [
        'title'
    ]
}
</script>




// WEBPACK FOOTER //
// data-loader.vue?47dedefd